module.exports = __webpack_public_path__ + "static/media/8-1.26814c8f.png";